import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get Video uploader url - AWS
 * @param course_id
 * @param version
 * @param parts
 * @param file
 * @param fileType
 * @param abortController
 */
const getPrivateContentUploadURL = (
  course_id: string,
  version: number,
  parts: number,
  file: string,
  fileType: 'video' | 'image' | 'resource',
  abortController: AbortController
): Promise<{ file: string; uploadId: string; urls: string[] }> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/private-file-url'
    const data = { parts, file, fileType: `${fileType}s` }
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
      signal: abortController.signal,
    }
    AxiosClient.post(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getPrivateContentUploadURL
